import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-solo-placements',
  templateUrl: './lol-placements.component.html'
})
export class LolPlacementsComponent {
  protected readonly DivisionsService = DivisionsService;

  service = 'placements';
  availableServices = services['lol'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'lol',
    service: 'placements',
    type: 'solo',
    title: {
      en: 'Placements',
    },
    subtitle: {
      en: 'Guaranteed 80% Win Ratio (4 out of 5 Placements) in Solo or Duo Boosting',
      fr: 'Taux de victoire garanti de 80 % (4 placements sur 5) en boosting solo ou duo',
      de: 'Garantierte 80% Gewinnquote (4 von 5 Platzierungsspiele) im Solo oder Duo Boosting',
      pt: 'Rácio de vitória garantido de 80% (4 em 5 placements) em Solo ou Duo Boosting',
      es: 'Tasa de victorias garantizada del 80% (4 de cada 5 clasificaciones) en Solo o Duo Boosting',
    },
    start: DivisionsService.getValueByRank('Gold I', 'lol'),
    desired: 5,
    serviceName: {
      en: 'Matches',
      fr: 'Parties',
      de: 'Spiele',
      pt: 'Jogos',
      es: 'Partidas',
    },
    min: 1,
    max: 5
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Placement Boosting Service?",
        answer: "Placement boosting is a form of LoL elo boosting that guarantees a minimum number of wins in a set number of placement matches: 4 out of 5, 3 out of 4, 2 out of 3, 1 out of 2, and 0 out of 1."
      },
      {
        question: "What If I Dont Get At Least 80% Win Ratio?",
        answer: "Our typical placements win rate is above 88%, but if it drops below 80%, you will be compensated with net wins. The final win rate determines the total amount of net wins that are awarded as store credits."
      },
      {
        question: "Is the Win Ratio the Same Across All Ranks?",
        answer: "Given the competitive nature of Master and Grandmaster games, the minimum number of wins for those ranks is of 3 out of 5, 2 out of 4, 2 out of 3, 1 out of 2, and 0 out of 1."
      },
      {
        question: "What If I Was Ranked Before But Not In The Last Season?",
        answer: "Choose the rank you held during your most recent season of ranked play. Despite not being ranked during the previous season, your MMR did not decrease, and you will queue with players of the same rank as before."
      },
      {
        question: "Can I Still Purchase If I have Already Played One Or More Placements?",
        answer: "Indeed, you can. Simply select your previous season rank and the number of remaining placements from the banner above."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now.\""
      },
      {
        question: "Can I Choose My Preferred Champions/Roles And Summoner Spell Order?",
        answer: "Yes, you can. Click the \"Choose your Roles\" and \"Choose your Champions\" options in the order customization menu to make it happen."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Service de Boosting de Placement?",
        answer: "Le boosting de placement est une forme de boosting d\'elo sur LoL qui garantit un nombre minimum de victoires pour un nombre défini de parties de placement : 4 sur 5, 3 sur 4, 2 sur 3, 1 sur 2 et 0 sur 1."
      },
      {
        question: "Que se passe-t-il si je n\'obtiens pas un ratio de victoire d\'au moins 80%?",
        answer: "Notre taux de victoire typique pour les placements est supérieur à 88%, mais s\'il tombe en dessous de 80 %, vous serez compensé par des victoires nettes. Le taux de victoire final détermine le montant total des victoires nettes qui sont attribuées sous forme de crédits de boutique."
      },
      {
        question: "Le ratio de victoires est-il le même pour tous les rangs?",
        answer: "Compte tenu de la nature compétitive des parties de maître et de grand maître, le nombre minimum de victoires pour ces rangs est de 3 sur 5, 2 sur 4, 2 sur 3, 1 sur 2 et 0 sur 1."
      },
      {
        question: "Que se passe-t-il si j\'ai été classé auparavant mais pas lors de la dernière saison?",
        answer: "Choisissez le rang que vous occupiez lors de votre dernière saison de jeu classé. Bien que vous n\'ayez pas été classé au cours de la saison précédente, votre MMR n\'a pas diminué et vous jouerez avec des joueurs du même rang qu\'auparavant."
      },
      {
        question: "Puis-je encore acheter si j\'ai déjà participé à une ou plusieurs parties de placement?",
        answer: "En effet, vous pouvez le faire. Il vous suffit de sélectionner votre rang de la saison précédente et le nombre de parties de placement restantes dans la bannière ci-dessus."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes champions/rôles préférés et l\'ordre des sorts d\'invocateur?",
        answer: "Oui, vous le pouvez. Cliquez sur les boutons 'Choisissez vos Rôles' et 'Choisissez votre Champion' dans le menu de personnalisation de la commande pour le faire."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Placement-Boosting-Service?",
        answer: "Placement-Boosting ist eine Form des LoL-Elo-Boosting, bei der eine Mindestanzahl an Siegen in einer bestimmten Anzahl von Placement-Matches garantiert wird: 4 aus 5, 3 aus 4, 2 aus 3, 1 aus 2 und 0 aus 1."
      },
      {
        question: "Was ist, wenn ich nicht mindestens 80% Gewinnquote erreiche?",
        answer: "Unsere typische Platzierungs-Win-Rate liegt bei über 88%, aber sollte sie unter 80% fallen, werden Sie mit Net Wins entschädigt. Die endgültige Gewinnrate bestimmt den Gesamtbetrag der Net Wins, die als Ladenkredite vergeben werden."
      },
      {
        question: "Ist das Gewinnverhältnis in allen Rängen gleich?",
        answer: "Aufgrund des wettbewerbsintensiven Charakters von Master - und Grandmasterspielen beträgt die Mindestanzahl an Siegen für diese Ränge 3 aus 5, 2 aus 4, 2 aus 3, 1 aus 2 und 0 aus 1."
      },
      {
        question: "Was ist, wenn ich vorher rangiert war, aber nicht in der letzten Saison?",
        answer: "Wähle den Rang aus, den du in deiner letzten Saison hattest. Auch wenn du in der vorherigen Saison nicht rangiert warst, ist dein MMR nicht gesenkt worden, und du wirst mit Spielern des gleichen Rangs wie zuvor spielen."
      },
      {
        question: "Kann ich noch kaufen, wenn ich bereits ein oder mehrere Platzierungsspiele gespielt habe?",
        answer: "Ja, das ist möglich. Wähle einfach deinen Rang aus der vorherigen Saison und die Anzahl der verbleibenden Platzierungsspiele aus."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: " Kann ich meine bevorzugten Champions/Rollen und die Reihenfolge der Beschwörerzauber wählen?",
        answer: "Ja, das können Sie. Klicken Sie auf die Schaltflächen 'Wähle deine Rollen' und 'Wähle deinen Champion' im Bestell-Anpassungsmenü, um es zu tun."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O que é um serviço de Placement Boosting?",
        answer: "Placement Boosting é uma forma de elo boosting que garante um número mínimo de vitórias num determinado número de placements: 4 de 5, 3 de 4, 2 de 3, 1 de 2 e 0 de 1."
      },
      {
        question: "O Que Acontece Se Eu Não Conseguir Pelo Menos 80% De Rácio De Vitórias?",
        answer: "A nossa percentagem média de vitórias em placements está acima de 88%, mas se cair abaixo de 80%, serás compensado com net wins, na forma de store credits, de acordo com a percentagem de vitórias final."
      },
      {
        question: "A taxa de vitórias é a mesma em todos os rankings?",
        answer: "Dada a natureza competitiva dos jogos em Master e Grandmaster, o número mínimo de vitórias para esses rankings é de 3 de 5, 2 de 4, 2 de 3, 1 de 2 e 0 de 1."
      },
      {
        question: "E Se Eu Já Tivesse Sido Ranked Antes, Mas Não Na Última Season?",
        answer: "Nesse caso escolhe o rank que tiveste na última vez que foste ranked. Apesar de não teres obtido rank na season anterior, o teu MMR não diminui e terás queues com jogadores no mesmo rank de antes."
      },
      {
        question: "Posso Comprar Se Já Joguei Um Ou Mais Jogos De Placements?",
        answer: "Sim, podes. Basta selecionar o teu rank da season anterior e o número de placements em falta."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para isso, vai ao menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost agora\"."
      },
      {
        question: "Posso escolher os meus Roles/Champions preferidos e a ordem dos summoner spells?",
        answer: "Sim, pode. Clique nos botões \"Escolher as suas Roles e Champions\" e \"Escolher os Summoner Spells\" no menu de personalização do pedido para fazer isso."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que tu queiras entrar na queue no mesmo modo de classificação que o serviço comprado. Fora isso, agende-o no chat do pedido com o teu booster."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de Boost de clasificación?",
        answer: "Boost de clasificación es una forma de boosting de elo en LoL que garantiza un número mínimo de victorias en un número determinado de partidos de clasificación: 4 de 5, 3 de 4, 2 de 3, 1 de 2 y 0 de 1."
      },
      {
        question: "¿Qué pasa si no consigo al menos un 80% de porcentaje de victorias?",
        answer: "Nuestro porcentaje típico de ganancias en las clasificaciones es superior al 88%, pero si cae por debajo del 80%, se le compensará con ganancias netas. El porcentaje de ganancias final determina la cantidad total de ganancias netas que se conceden como créditos de la tienda."
      },
      {
        question: "¿Es el porcentaje de victorias el mismo en todos los rangos?",
        answer: "Dada la naturaleza competitiva de las partidas de Master y Grandmaster, el número mínimo de victorias para esos rangos es de 3 sobre 5, 2 sobre 4, 2 sobre 3, 1 sobre 2 y 0 sobre 1."
      },
      {
        question: "¿Qué pasa si antes estaba clasificado pero no en la última temporada?",
        answer: "Elige el rango que tenías durante tu última temporada de juego clasificado. A pesar de no haber sido clasificado durante la temporada anterior, tu MMR no ha disminuido y harás cola con jugadores del mismo rango que antes."
      },
      {
        question: "¿Puedo seguir comprando si ya he jugado una o más clasificaciones?",
        answer: "En efecto, puedes hacerlo. Solo tienes que seleccionar tu clasificación de la temporada anterior y el número de clasificaciones restantes en el banner de arriba."
      },
      {
        question: "¿Puedo jugar con los boosters en Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Puedo elegir mis campeones/roles preferidos y el orden de los hechizos de invocador?",
        answer: "Sí, puedes hacerlo. Haz clic en las opciones \"Elige tus roles\" y \"Elige tus campeones\" en el menú de personalización del pedido para que esto suceda."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "LoL Boost - Placements Boosting for League of Legends",
      fr: "Boost LoL - Boosting de Placements pour League of Legends",
      de: "LoL Boost - Placements Boosting für League of Legends",
      pt: "LoL Boost - Boost de placements para League of Legends",
      es: "LoL Boost - Boost de clasificación para League of Legends",
    },
    metaDescription: {
      en: "Our Master+ boosters ensure that you have a win ratio of at least 70% in the most critical League of Legends matches of the season",
      fr: "Nos boosters Maître+ vous garantissent un taux de victoire d\'au moins 70% lors des parties de League of Legends les plus importantes de la saison.",
      de: "Mit unseren Master+ Boostern ist sichergestellt, dass du in den kritischsten League of Legends Matches der Saison eine Siegchance von mindestens 70% hast.",
      pt: "Os nossos boosters Master+, garantem que tu tenhas uma taxa de vitória de pelo menos 70% nos jogos mais críticos da temporada de League of Legends",
      es: "Nuestros boosters Master+ te garantizan un porcentaje de victorias de al menos el 70% en los partidos más importantes de la temporada de League of Legends.",
    }
  }

  private lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private cookie: CookieService, private translationService: TranslationService,) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        }
      );
    });
  }
}